export default __webpack_public_path__ + "static/media/HomepplLogo-full.eca2c640.svg";